import * as React from 'react';
// @ts-ignore
import { useState } from "react";
import RequestCreate from "../../components/RequestCreate";
// @ts-ignore
import order from "../../order.pdf";
import {ActionsRules} from "../../const/action_rules";
import RequestList from "../../components/RequestList";

const InvestorsMainPage = ({mode, user, forms}) => {
    const [showHint, setShowHint] = useState(false);

    return <div className='content'>
        <div className='d-flex'>
            <h2 className='content__title'>Запрос инвестора о заключении договора о возмещении части затрат</h2>
            <button type="button" className="btn btn-clear" onClick={() => setShowHint(!showHint)}>
                <span className="glyphicon glyphicon-question-sign"  ></span>
            </button>
        </div>
        {showHint && <div className="alert alert-info hint">
          Настоящая заявка направляется для целей исполнения Правил предоставления субсидии из федерального бюджета некоммерческой организации Фонд развития Центра разработки и коммерциализации новых технологий на возмещение части затрат физическим лицам, осуществившим инвестиции на ранних стадиях в юридические лица, получившие статус участника проекта создания и обеспечения функционирования инновационного центра "Сколково", определяемой исходя из объема уплаченного налога на доходы физических лиц и не превышающей 50 процентов таких инвестиций, утвержденных постановлением Правительства Российской Федерации от 17 августа 2019 года № 1070 со всеми изменения и дополнениями (далее – Правила, Фонд)
        </div>}
        <ul className="list-unstyled">
            <li><a className="btn-link" href="/angels/static/files/БА Инструкция для инвестора оформление заявки.pdf" target="__blank">Инструкция по оформлению заявки</a></li>
        </ul>
        <div className='line'/>
        {mode === 'working' && (
            <div className='container-fluid nopad'>
                {/*@ts-ignore*/}
                <RequestCreate needORN={false}/>
            </div>
        )}
        {mode === 'suspended' && (
            <div className='container-fluid nopad'>
                <p style={{color: 'red'}}>Приём заявок временно приостановлен</p>
                <a className="btn-link" target="_blank" href={order}>Приказ</a>
            </div>
        )}
        <div className='line'/>
        {typeof user !== 'undefined'
            && forms.findIndex(item => item.form_status=== 18) > -1
            && user.userRole === 'user'
            && (
                <div className='container-fluid nopad'>
                    <div className='main-alert' dangerouslySetInnerHTML={{ __html: ActionsRules['user'][18].mainPageAlert }} />
                </div>
            )}
        <div className='container-fluid nopad'>
            <h4>Все заявки</h4>
            <RequestList/>
        </div>
    </div>
}

export default InvestorsMainPage;